module.exports = __webpack_public_path__ + "static/bg-header-conversions-eb999cea4578486454adfe5372344d1a.svg";